import { WhatsappLogo } from '@phosphor-icons/react';

const WHATSAPP_NUMBER = '+6285921774979';

export const WhatsAppButton = () => {
  const message = encodeURIComponent('Halo XGRIDS Indonesia, saya tertarik dengan produk Anda.');
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 group"
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-white text-gray-800 text-sm px-3 py-2 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        Chat via WhatsApp
      </span>
    </a>
  );
};

export const WhatsAppLink = ({ children, message = '', className = '' }) => {
  const defaultMessage = 'Halo XGRIDS Indonesia, saya tertarik dengan produk Anda.';
  const encodedMessage = encodeURIComponent(message || defaultMessage);
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      data-testid="whatsapp-link"
    >
      {children}
    </a>
  );
};
